function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Drawer, Modal, DatePicker, Input, Tag, Space } from 'antd';
import { Table } from 'react-bootstrap';
import { Search as SearchIcon, Eyedropper, BootstrapReboot, BoxSeamFill, CashStack, EyeFill, PenFill, Capsule, CardText } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import PickConsummable from "../components/PickConsumables";
import CashIn from "../components/forms/CashIn";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;

var Chirurgie = function Chirurgie() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentDept = _useState2[0],
      setCurrentDept = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptList = _useState4[0],
      setDeptList = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDeptDataLoading = _useState6[0],
      setIsDeptDataLoading = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      queueData = _useState8[0],
      setQueueData = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      currentQueueItem = _useState10[0],
      setCurrentQueueItem = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      searchId = _useState12[0],
      setSearchId = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isOrderModalOpen = _useState14[0],
      setIsOrderModalOpen = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isCashInModalOpen = _useState16[0],
      setIsCashInModalOpen = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isConsumableModalOpen = _useState18[0],
      setIsConsumableModalOpen = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      customers = _useState20[0],
      setCustomers = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      dataChanged = _useState22[0],
      setDataChanged = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      isDataLoading = _useState24[0],
      setIsDataLoading = _useState24[1];

  var onSearch = function onSearch(v) {
    setSearchId('');

    if (v.length > 0) {
      setSearchId(v);
    }
  };

  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};

  useEffect(function () {
    setDataChanged(false);
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep = response.data.departments.filter(function (d) {
          return d.dcode == 'CHI';
        });
        if (dep.length > 0) setCurrentDept(dep[0]);
        axios.get(Common.baseApiUrl + "getdailychqueue/" + dep[0].id.toString()).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {}); //GET CASHIER DATA

    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString())]).then(function (response) {
      setIsDataLoading(false);

      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyedropper, {
                  size: 30
                }), "File d'attente"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  size: "sm",
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "CODE P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte(s) prescrit(s)"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(q.created_at).toLocaleDateString('fr')
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), "                                                ", /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "vertical",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (item) {
                              return /*#__PURE__*/_jsx(Tag, {
                                color: "red",
                                icon: /*#__PURE__*/_jsx(Capsule, {
                                  size: 15
                                }),
                                children: /*#__PURE__*/_jsx("b", {
                                  children: item.medical_item.label
                                })
                              }, item.medical_item.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsxs(Space, {
                            direction: "horizontal",
                            children: [/*#__PURE__*/_jsx(Button, {
                              type: "primary",
                              style: {
                                background: '#F0C82F'
                              },
                              onClick: function onClick() {
                                setCurrentQueueItem(q);
                                setIsOrderModalOpen(true);
                              },
                              children: /*#__PURE__*/_jsx(CardText, {
                                size: 23
                              })
                            }), /*#__PURE__*/_jsx(Button, {
                              type: "primary",
                              onClick: function onClick() {
                                setCurrentQueueItem(q);
                                setIsConsumableModalOpen(true);
                              },
                              children: /*#__PURE__*/_jsx(BoxSeamFill, {
                                size: 23
                              })
                            }), /*#__PURE__*/_jsx(Button, {
                              type: "primary",
                              style: {
                                background: '#47A03A'
                              },
                              onClick: function onClick() {
                                setCurrentQueueItem(q);
                                setIsCashInModalOpen(true);
                              },
                              children: /*#__PURE__*/_jsx(CashStack, {
                                size: 23
                              })
                            }), /*#__PURE__*/_jsx(Button, {
                              type: "link",
                              href: "/#/home/patient/" + q.customer.idnumber,
                              style: {
                                background: '#DB712D'
                              },
                              children: /*#__PURE__*/_jsx(EyeFill, {
                                color: {
                                  color: "#EEE"
                                },
                                size: 23
                              })
                            })]
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BootstrapReboot, {
                  size: 30
                }), "Trait\xE9(s)"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                children: /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte (s) prescrit(s)"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(q.created_at).toLocaleDateString('fr')
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "vertical",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (item) {
                              return /*#__PURE__*/_jsx(Tag, {
                                color: "red",
                                icon: /*#__PURE__*/_jsx(Capsule, {
                                  size: 15
                                }),
                                children: /*#__PURE__*/_jsx("b", {
                                  children: item.medical_item.label
                                })
                              }, item.medical_item.id);
                            })
                          })
                        }), /*#__PURE__*/_jsxs("td", {
                          children: [/*#__PURE__*/_jsx(Button, {
                            size: "small",
                            type: "primary",
                            onClick: function onClick() {
                              setCurrentQueueItem(q);
                              setIsOrderModalOpen(true);
                            },
                            children: "Revoir le rapport"
                          }), /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: null,
                            href: "/#/home/patient/" + q.customer.idnumber,
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "CONSULTER"
                            })
                          })]
                        })]
                      }, q.id);
                    })
                  })]
                })
              })
            }, 3)]
          })
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      destroyOnClose: true,
      visible: isOrderModalOpen,
      headerStyle: {
        background: '#F08A8D',
        borderRadius: '0px'
      },
      onClose: function onClose() {
        setIsOrderModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsxs("b", {
        children: ["RAPPORT D'INTERVENTION ", /*#__PURE__*/_jsx(PenFill, {
          size: 20
        })]
      }),
      width: "70%",
      children: currentQueueItem && /*#__PURE__*/_jsx(_Fragment, {})
    }), /*#__PURE__*/_jsx(Modal, {
      destroyOnClose: true,
      visible: isConsumableModalOpen,
      headerStyle: {
        background: '#F08A8D',
        borderRadius: '0px'
      },
      onCancel: function onCancel() {
        setIsConsumableModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsxs("b", {
        children: ["CONSOMMABLE ", /*#__PURE__*/_jsx(PenFill, {
          size: 20
        })]
      }),
      width: "70%",
      children: currentQueueItem && /*#__PURE__*/_jsx(PickConsummable, {})
    }), /*#__PURE__*/_jsx(Modal, {
      destroyOnClose: true,
      visible: isCashInModalOpen,
      headerStyle: {
        background: '#F08A8D',
        borderRadius: '0px'
      },
      onCancel: function onCancel() {
        setIsCashInModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsxs("b", {
        children: ["ENCAISSEMENT ", /*#__PURE__*/_jsx(PenFill, {
          size: 20
        })]
      }),
      width: "70%",
      children: currentQueueItem && /*#__PURE__*/_jsx(CashIn, {})
    })]
  });
};

export default Chirurgie;